module.exports = __webpack_public_path__ + "img/spartan-demolition-sitework-04-med.6cf0673c.jpg";